// @flow

import { RECEIVE_HEALTH_GUIDE, REMOVE_HEALTH_GUIDE } from '../constants/guide';

export { default as cache } from 'universal/reducers/cache';
export { default as siteConfigs } from 'client/reducers/siteConfigs';
export { default as translations } from 'client/reducers/translations';
export const brand = (state: string = 'stride') => state;
export const healthGuide = (state = {}, action) => {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_HEALTH_GUIDE:
      return action.healthGuide;
    case REMOVE_HEALTH_GUIDE:
      return {};
    default:
      return state;
  }
};
